import { Button } from "@/components/ui/button";
import { Container } from "@/components/design-system/Container";
import { LanguageSelector } from "@/components/LanguageSelector";
import { ChevronDown } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useNavigate, useLocation } from "react-router-dom";

export const ComingSoonHeader = ({ onContactClick }: { onContactClick: () => void }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentLang = location.pathname.split('/')[1] || 'en';

  const handleLanguageChange = (lang: string) => {
    navigate(`/${lang}/coming-soon`);
  };

  const handleLogoClick = () => {
    navigate(`/${currentLang}/coming-soon`);
  };

  return (
    <header className="fixed w-full top-0 bg-white/80 backdrop-blur-md border-b z-50">
      <Container>
        <div className="flex items-center justify-between h-16">
          <button 
            onClick={handleLogoClick} 
            className="flex items-center gap-2 hover:opacity-90 transition-opacity"
          >
            <img 
              src="/LogoPorteroYa.svg" 
              alt="PorteroYa Logo" 
              width={48}
              height={48}
              className="h-12 w-12"
            />
            <span className="text-xl font-bold text-primary">PorteroYa</span>
          </button>
          <div className="flex items-center gap-4">
            {/* Desktop Language Selector */}
            <div className="hidden md:block">
              <LanguageSelector currentPath={location.pathname} />
            </div>
            
            {/* Mobile Language Dropdown */}
            <div className="md:hidden">
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button 
                    variant="ghost" 
                    size="sm"
                    className="text-sm font-medium hover:text-primary transition-colors"
                  >
                    <span className="mr-1">{currentLang.toUpperCase()}</span>
                    <ChevronDown className="h-4 w-4" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="bg-white">
                  <DropdownMenuItem onClick={() => handleLanguageChange('es')}>
                    ES
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => handleLanguageChange('ca')}>
                    CA
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={() => handleLanguageChange('en')}>
                    EN
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>

            <Button 
              variant="secondary"
              className="bg-primary/10 hover:bg-primary/20 text-primary"
              onClick={onContactClick}
            >
              Contact Us
            </Button>
          </div>
        </div>
      </Container>
    </header>
  );
};